<template>
    <div>

        <!-- Todos -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-list-ul"></i>
            </h2>
            <div class="w-100">
                <h2>
                    Todo
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#todos-container" aria-expanded="true" aria-controls="todos-container">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div class="collapse" :class="{'show': componentIsVisable}" id="todos-container">
            <div class="todos">
                <div class="accordion accordion-flush">

                    <div class="d-flex flex-column flex-sm-row">
                        <div class="d-flex gap-4 gap-sm-0 w-100 mb-4 mt-sm-0">
                            <div class="text-decoration-none ms-sm-auto text-nowrap" style="cursor: pointer">
                                <span class="bg-lightyellow text-primary round-btn me-2">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </span>
                                    <span class="fw-semibold" @click="showCreateForm = true">
                                    Nieuwe todo
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Eigen todos -->
                    <my-todos v-if="showMyTodos" :showCreateForm="showCreateForm" @hideForm="showCreateForm = false"></my-todos>

                    <!-- Nabellen -->
                    <todos-call-back v-if="showCallBack"></todos-call-back>

                    <!-- Afspraak inplannen -->
                    <todos-schedule-appointment v-if="showScheduleAppointment"></todos-schedule-appointment>

                    <!-- Nieuwe offertes -->
                    <todos-new-offer v-if="showNewOffer"></todos-new-offer>

                    <!-- Controle offertes -->
                    <todos-controle-offer v-if="showControleOffer"></todos-controle-offer>

                    <!-- Opdracht offertes -->
                    <todos-assignment-offer v-if="showAssignmentOffer"></todos-assignment-offer>

                    <!-- Opleverpunten offertes -->
                    <todos-delivery-point v-if="showDeliveryPoint"></todos-delivery-point>

                    <!-- Openstaande betaalverzoeken -->
                    <todos-open-payment-request v-if="showOpenPaymentRequest"></todos-open-payment-request>

                    <!-- Openstaande montages -->
                    <todos-stale-assemblies v-if="showStaleAssemblies"></todos-stale-assemblies>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import MyTodos from "./Todos/MyTodos.vue";
import TodosCallBack from "./Todos/TodosCallBack.vue";
import TodosScheduleAppointment from "./Todos/TodosScheduleAppointment.vue";
import TodosNewOffer from "./Todos/TodoNewOffer.vue";
import TodosControleOffer from "./Todos/TodoControleOffer.vue";
import TodosAssignmentOffer from "./Todos/TodoAssignmentOffer.vue";
import TodosDeliveryPoint from "./Todos/TodosDeliveryPoint.vue";
import TodosOpenPaymentRequest from "./Todos/TodosOpenPaymentRequest.vue";
import TodosStaleAssemblies from "./Todos/TodosStaleAssemblies.vue";

export default {
    name: 'todos',
    components: {
        MyTodos,
        TodosCallBack,
        TodosScheduleAppointment,
        TodosNewOffer,
        TodosControleOffer,
        TodosAssignmentOffer,
        TodosDeliveryPoint,
        TodosOpenPaymentRequest,
        TodosStaleAssemblies,
    },
    props: {
        showMyTodos: Boolean,
        showCallBack: Boolean,
        showScheduleAppointment: Boolean,
        showNewOffer: Boolean,
        showControleOffer: Boolean,
        showAssignmentOffer: Boolean,
        showDeliveryPoint: Boolean,
        showOpenPaymentRequest: Boolean,
        showStaleAssemblies: Boolean,
        isVisible: Boolean,
    },
    data() {
        return {
            showCreateForm: false,
            componentId: 'todo-component',
            componentIsVisable: this.isVisible,
        };
    },
    computed: {},
    watch: {},
    methods: {
        updateComponentVisability(component_id) {
            // Toggle the visibility state
            this.componentIsVisable = !this.componentIsVisable;
            axios.get('api/update-component-visability', {
                params: {
                    component_id: component_id,
                    is_visable: this.componentIsVisable
                }
            });
        },
        fetchComponentIsVisable() {
            axios.get('api/todo-component-is-visable')
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.componentId = response.data.componentId;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
    },
    mounted() {
        this.fetchComponentIsVisable();
    },
    created() {},
}
</script>
